import { isDisabled } from '@testing-library/user-event/dist/utils';
import React, {useState, useEffect} from 'react'
import './AddFamilyModal.css'

import { db, storage } from '../utils/User/include/Authorize'
import { useStateValue } from '../utils/Provider/StateProvider';

function AddFamilyModal(props) {

    

    const [{ user, myfamily, treenode }, dispatch] = useStateValue();
    
    const [step, nextStep] =useState(true);
    const color = [
        'rgb(243, 125, 14)',
        'rgb(226, 35, 35)',
        'rgb(243, 239, 14)',
        'rgb(136, 255, 0)',
        'rgb(78, 172, 70)',
        'rgb(199, 12, 143)',
        'rgb(45, 124, 243)',
        'rgb(47, 187, 187)',
        'rgb(226, 35, 153)',
        'rgb(226, 35, 226)',
        'rgb(194, 96, 51)',
        'orangered',
        'salmon',
        'darkcyan',
        'gold',
        'goldenrod',
        'purple'
    ]

    const [personName, setPersonName] = useState('');
    const [familyName, setFamilyName] = useState('');
    const [DOB, setDOB] = useState('');
    const [relation_is, setRelation_is] = useState('My Self');
    const [custom_relation, setCustomRelation] = useState('');
    const [IcallHim, setICallHim] = useState('kaka');
    const [custom_ICallHim, setCustomICallHim] = useState('');
    const [is_married, setIsMarried] = useState('');
    const [married_to, setMarriedTo] = useState('');
    const [contact_detail, setContactDetail] = useState('');
    const [location_detail,setLocationDetail ] = useState('');
    const [describe_person,setDescribePerson ] = useState('');
    const [errorNotify,setErrorNotify ] = useState('💡 No Suggestions');

    const [person_data,setPersonData ] = useState([]);


    // Data for TreeView:
    const [known_by, setKnownBy] = useState(myfamily ? myfamily[0].name : 'error')
    const [known_as, setKnownAs] = useState('friend')
    const [custom_knownas, setCustomKnownAs] = useState('')

    // just for knownby_field:
    
    const [uploadImage, setUploadImage] = useState(null)

    // Const Choose Color Randomly:
    const getColor = () => {
        const len = color.length;
        return color[Math.floor(Math.random() * len)]
    }

    // my Family:
    const myFamilyToDB = () => {
        console.log("Adding family to db", person_data)
        if(user){
            person_data.map(data => {
                    
                
            db.collection(user.email)
                .doc('Family')
                .collection('members')
                .add(
                    data
                )
                .catch(error => 
                    dispatch({
                        type: 'NOTIFY_ERROR',
                        error: error.message 
                    })
                )

            })
        }
    }

    // My Relative to DB:
    const myRelativeToDB = () => {

            

        if(user){

            console.log("relatives: ", person_data)
            db.collection(user.email)
                .doc("Relative")
                .collection('members')
                .add(
                    {person_data}
                )
                .catch(error => 
                    dispatch({
                        type: 'NOTIFY_ERROR',
                        error: error.message 
                    })
                )
                
        }

        

    }

    // GO to next Step:
    const goTonextStep = () => {

        if (props.type === 'my_relative' && known_by === 'error'){
            setErrorNotify("❗ Add Your Family First")
        }
        else if (props.type === 'my_relative' && known_as === 'custom' && custom_knownas === ""){
            setErrorNotify("❗ Related as is set to custom -- Custom field Required !")
        }
        else if (props.type === 'my_relative' && known_as !== 'custom' && custom_knownas !== ""){
            setErrorNotify("❗ Related as field is not custom - Remove the custom field !")
        }
        else {
            // document.getElementById('family_name_field').disabled = true
            // document.getElementById('known_by_field').disabled = true
            // document.getElementById('known_as_field').disabled = true
            // document.getElementById('customknown_as_field').disabled = true

            setErrorNotify("First step completed")
            
            nextStep(false)
        }
        
    }

    // Random position generator:
    const randomX = () => {
        return Math.floor(Math.random() * (700 - 50 + 1)) + 50;
    }

    const randomY = () => {
        return Math.floor(Math.random() * (1000 - 20 + 1)) + 20;
    }

    const [savingPerson, setSavingPerson] = useState(false)

    // Add Data to DataBase:
    const submitDataToFB = () => {

        if(person_data.length === 0){
            setErrorNotify("⚠️ Add Records First")
            return
        }


        setSavingPerson(true)
        if(props.type === 'my_family'){
                
                UploadImageToDB()

                myFamilyToDB()


                resetFields();
                setSavingPerson(false)
                setFamilyName('')
                props.onCloseHandler()  
                
                
        } else if(props.type === 'my_relative'){
            UploadImageToDB()

            myRelativeToDB()
            
            resetFields();
            setFamilyName('')   
            setSavingPerson(false)
            props.onCloseHandler()
        }

        // Else add other Relatives Family

        setKnownBy(myfamily ? myfamily[0].name : 'error')
        setKnownAs('')

    }

    // Remove data from person_data List:
    const removeThisPersonRecord = (id, name) => {
        setPersonData(person_data.filter(item => item.name !== name))
    }

    // Add Person to data State
    const addPerson = () => {
        
        if(personName === ''){
            setErrorNotify("❗ Name is required")
        }
        // else if (DOB === ""){
        //     setErrorNotify("❗ DOB is required")
        // }
        else if (relation_is !== "custom" && custom_relation !== ""){
            setErrorNotify("❗ Relation_type is not custom. Please, remove this field ")
        }
        else if (relation_is === "custom" && custom_relation === ""){
            setErrorNotify("❗ Custom selected but {empty-field}")
        }
        else if (IcallHim !== "custom" && custom_ICallHim !== ""){
            setErrorNotify("❗ 'call him' is not custom. Please, remove this field ")
        }
        else if (IcallHim === "custom" && custom_ICallHim === ""){
            setErrorNotify("❗ Custom 'call him' selected but {empty-field}")
        }
        else if (is_married === ''){
            setErrorNotify("❗ Marriage Status required")
        }
        else if (is_married === 'yes' && married_to === ""){
            setErrorNotify("❗ Married with Field required ")
        }
        else if (is_married === 'no' && married_to !== ""){
            setErrorNotify("❗ Wrong Entry [Person is not married Field must be Empty")
        }
        else{
            setErrorNotify("✔️ No errors found")

            person_data.push({
                'family_name' : familyName,
                'name' : personName,
                'DOB' : DOB === '' ? null : DOB,
                'relation_is' : relation_is,
                'custom_relation' : custom_relation === '' ? null : custom_relation,
                'call_him' : IcallHim ,
                'custom_call_him' : custom_ICallHim === '' ? null : custom_ICallHim,
                'is_married': is_married,
                'married_to' : married_to === '' ? null : married_to,
                'contact_detail' : contact_detail === '' ? null : contact_detail,
                'location_detail' : location_detail === '' ? null : location_detail,
                'describe_person' : describe_person === '' ? null : describe_person,
                'bgcolor' : `${getColor()}`,
                'uploadProfileImg': [uploadImage === null ? 'default' : uploadImage[0]],
                'known_by': known_by,
                'known_as': known_as,
                'custom_knownas': custom_knownas === '' ? null : custom_knownas,
                'aniversary' : null
            })

            console.log(person_data)
            resetFields()
            
            nextStep(true);
        } 
    }


    // Clear all Field States:
    const resetFields = () =>{

        setPersonName('')
        setDOB('')
        setRelation_is('My Self')
        setCustomRelation('')
        setICallHim('Kaka')
        setCustomICallHim('')
        setIsMarried('')
        setMarriedTo('')
        setContactDetail('')
        setLocationDetail('')
        setDescribePerson('')
        setUploadImage(null)

    }


    // Upload Image to DB:
    const UploadImageToDB = ()=>{
        Object.keys(person_data).map(item => {
            if(person_data[item].uploadProfileImg[0] === 'default'){
                person_data[item].uploadProfileImg.pop()
                return
            } else {
                if(user){
                    const uploadTask = storage.ref(`${user.email}/people/${person_data[item].name}`)
                        .put(person_data[item].uploadProfileImg[0])
                    
                    uploadTask.on("state_changed" , 
                            setErrorNotify("Uploading Images..." + `${item}/${person_data.length}`) , 
                            (error)=>{
                                console.log("uploading image Error >> ",error);
                                
                            },
                            () => {
                                storage
                                    .ref(`${user.email}/people/${person_data[item].name}`)
                                    .getDownloadURL()
                                    .then(url =>{
                                        db.collection(user.email)
                                            .doc('peoples')
                                            .collection('images')
                                            .add({'url' : url, 'name': person_data[item].name})
                                            .catch(error => alert(error.message))

                                    })
                                    .catch(e => {
                                        dispatch({
                                            type: 'NOTIFY_ERROR',
                                            error: "Error >" + e
                                          })
                                    })
                            }
                        );

                    
                    person_data[item].uploadProfileImg.pop()
                }
            }
        })

        
        
    }


    return (
    <div className='addfamily_modal_container' id='addfamily_modal_container'>
        { step ?
            <div className='addfamily_modal_content'>
                <div className='addfamily_modal_content_header'>
                    <h3 className='addfamily_modal_content_title'>{props.type === 'my_relative' ? 'Create your Relative Family' : 'Add or Create your own Family'} </h3>
                    <span onClick={props.onCloseHandler}><i class="fa fa-times fa-lg" aria-hidden="true"></i></span>
                </div>

                <hr />

                <div className='addfamily_modal_step1'>
                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='family_name'>Family Name: &nbsp;</label>
                            <input type='text' className='max_width700' id='family_name_field' placeholder='Mention family name' value={familyName} onChange={e => setFamilyName(e.target.value)}/>
                        </div>
                    </div>
                    
                    <hr />
 
                {
                    props.type === 'my_family' ? 

                        null
                    :

                        <div>
                            <p style={{marginTop: '0px', fontWeight:'500', fontSize:'13px', color:'#999' }}>This Family is Relative of your eg(father, mother, yourself)  </p>
                            <p style={{marginTop: '0px', fontSize:'12px', color:'#ccc' }}>This field are required !</p>

                            <div className='addfamily_modal_row flex-row-spaceBetween'>
                                <div>
                                    <label for='known_by_field'>This Person is Relative of (your) : &nbsp;</label>
                                    <select id='known_by_field'  value={known_by} onChange={e => setKnownBy(e.target.value)} >

                                        {myfamily ? 
                                            Object.keys(myfamily).map(i => (
                                                <option value={myfamily[i].name}>{myfamily[i].name}</option>
                                            ))
                                            :
                                            <option value='error'>Add Family First</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            <div className='addfamily_modal_row flex-row-spaceBetween'>
                                <div>
                                    <label for='known_as_field'>Related as : &nbsp;</label>

                                    <select id='known_as_field'  value={known_as} onChange={e => setKnownAs(e.target.value)} >
                                        <option value='friend'>Friend</option>
                                        <option value='brother'>Brother</option>
                                        <option value='sister'>Sister</option>
                                        <option value='kaka'>Kaka</option>
                                        <option value='kaku'>Kaku</option>
                                        <option value='mama'>Mama</option>
                                        <option value='aatya'>Aatya</option>
                                        <option value='mami'>Mami</option>
                                        <option value='maushi'>Maushi</option>
                                        <option value='custom'>Custom</option>
                                    </select>

                                    <input type='text' className='max_width700' id='customknown_as_field' placeholder='if custom enter here'  value={custom_knownas} onChange={e => setCustomKnownAs(e.target.value)} />
                                    
                                </div>
                            </div>

                            <hr />  
                        </div>
                    }                             

                    <div className='addfamily_modal_persondata'>
                                
                        {person_data.length !== 0 ? 
                            
                            <table className='addfamily_modal_person_records'>
                                <tr>
                                    <th>Name</th>
                                    <th>Relation</th>
                                    <th>You Call Him</th>
                                    <th>Married</th>
                                    <th></th>
                                </tr>
                                
                                { Object.keys(person_data).map(id => (
                                    <tr>
                                        <td><b>{person_data[id].name}</b></td>
                                        <td>{person_data[id].relation_is}</td>
                                        <td>{person_data[id].call_him}</td>
                                        <td>{person_data[id].is_married}</td>
                                        <td><button className='addfamily_modal_person_records_remove_btn' onClick={() => removeThisPersonRecord(id, person_data[id].name)}><i class="fa fa-trash" aria-hidden="true"></i> &nbsp; Remove</button></td>
                                    </tr>
                                    ))
                                
                                }
                            </table>
                        :
                            <p style={{color: '#ccc', textAlign:'center'}}>Add records of Family Members</p>
                        }
                        
                    </div>                    
                </div>

                <hr />
                
                <div className='addfamily_modal_buttons'>

                    <div><span id='verification_msg' style={errorNotify === '✔️ No errors found' ? {backgroundColor: 'rgb(88, 255, 88)'} : null}>{errorNotify ? errorNotify : null}</span></div>

                    <div>
                        { familyName !== '' ?
                            <button className='addfamily_person_btn' onClick={() => goTonextStep()}>Add person</button>
                            :
                            null
                        }
                        
                        <button className='addfamily_submit_btn' style={ familyName === '' ? {cursor: 'not-allowed'} : null } disabled = {familyName === '' ? true : false }  onClick={() => submitDataToFB()}><p>{savingPerson ? "saving" : "Submit"}</p></button>
                    </div>
                </div>
            </div>

            : 
            

            // This below code intent to add person in a family {default_view: false}
            <div className='addfamily_modal_content'>
                <h3 className='addfamily_modal_content_title'>Add Person to The family</h3>
                <hr />

                <div className='addfamily_modal_step1'>
                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='person_name'>Name: &nbsp;</label>
                            <input type='text' className='max_width700' id='person_name' placeholder='Person Name' value={personName} onChange={e => setPersonName(e.target.value)} />
                        </div>

                        <div>
                            <label for='person_dob'>DOB: &nbsp;</label>
                            <input type='date' className='max_width700' id='person_dob' value={DOB} checked onChange={e => setDOB(e.target.value)} />
                        </div>
                    </div>

                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='relation_is'>{personName ? personName : 'Person'} is a (with-in this family) : &nbsp;</label>

                            <select id='relation_is'  value={relation_is} onChange={e => setRelation_is(e.target.value)} >
                                <option value='myself' selected>My Self</option>
                                <option value='father'>Father</option>
                                <option value='mother'>Mother</option>
                                <option value='son'>Son</option>
                                <option value='daughter'>Daughter</option>
                                <option value='sister'>Sister</option>
                                <option value='brother'>Brother</option>
                                <option value='kaka'>Kaka</option>
                                <option value='kaku'>Kaku</option>
                                <option value='mama'>Mama</option>
                                <option value='aatya'>Aatya</option>
                                <option value='mami'>Mami</option>
                                <option value='maushi'>Maushi</option>
                                <option value='custom'>Custom</option>
                            </select>

                            <input type='text' className='max_width700' id='custom_relation' placeholder='if custom enter here'  value={custom_relation} onChange={e => setCustomRelation(e.target.value)} />
                            
                        </div>
                    </div>
                    <p style={{marginTop: '0px', fontSize:'12px', color:'#ccc' }}>This means who is he/her in his Family eg(he is a father, his wife so a mother, their son, etc)</p>
                    
                    
                    <hr />
                    {/* I call Him Part */}
                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='i_call_him'>You call ({personName ? personName : 'Person'}) : &nbsp;</label>

                            <select id='i_call_him'  value={IcallHim} onChange={e => setICallHim(e.target.value)} >
                                <option value='father'>Father</option>
                                <option value='mother'>Mother</option>
                                <option value='sister'>Sister</option>
                                <option value='brother'>Brother</option>
                                <option value='kaka' selected>Kaka</option>
                                <option value='kaku'>Kaku</option>
                                <option value='mama'>Mama</option>
                                <option value='aatya'>Aatya</option>
                                <option value='mami'>Mami</option>
                                <option value='maushi'>Maushi</option>
                                <option value='custom'>Custom</option>
                            </select>

                            <input type='text' className='max_width700' id='custom_relation' placeholder='if custom enter here'  value={custom_ICallHim} onChange={e => setCustomICallHim(e.target.value)} />
                            
                        </div>
                    </div>
                    <p style={{marginTop: '0px', fontSize:'12px', color:'#ccc' }}>By what you call him/her eg(your uncle, etc)</p>


                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='is_married'>Married: &nbsp;</label>
                            <input type='radio' id='is_married' name='married_status' value='yes' onClick={e => setIsMarried(e.target.value)} /> Yes &nbsp;
                            <input type='radio' id='is_married' name='married_status' value='no' onClick={e => setIsMarried(e.target.value)} /> No &nbsp;
                        </div>

                        <div>
                            <label for='married_to'>Married with : &nbsp;</label>
                            <input type='text' className='max_width700' id='married_to' placeholder='If yes then Married with ? ' value={married_to}  onChange={e => setMarriedTo(e.target.value)}  />
                        </div>
                    </div>

                    <div className='addfamily_modal_row flex-row-spaceBetween'>
                        <div>
                            <label for='contact_detail'>Contact: &nbsp;</label>
                            <input type='tel' className='max_width700' id='contact_detail' placeholder='Contact' value={contact_detail}  onChange={e => setContactDetail(e.target.value)} />
                        </div>

                        <div>
                            <label for='location_detail'>Location: &nbsp;</label>
                            <input type='text' className='max_width700' id='location_detail' placeholder='Stays in '  value={location_detail}  onChange={e => setLocationDetail(e.target.value)}  />
                        </div>
                    </div>


                    <br></br>
                    <label for='describe_person' style={{marginBottom: '10px'}}>Description : &nbsp;</label>
                    <br />
                    <textarea id='describe_person' className='max_width700' placeholder='Describe more about person' noresize  value={describe_person}  onChange={e => setDescribePerson(e.target.value)} ></textarea>

                    <br/>
                    <label style={{marginBottom: '10px'}}>Upload Image : &nbsp;</label>
                    <input type="file" onChange={(e) => setUploadImage(e.target.files)}/>
                    {/* <p>{uploadImage}</p> */}

                    {/* { uploadImage === '' ?
                        null
                        :
                        <button id='uploac_img' className='addfamily_modal_upload_btn' onClick={() => UploadImageToDB()} >Upload</button>
                    } */}


                {/* Remove Upload Button, Add Person Name to image and upload img on submit Event  */}


                    
                    
                </div>
                <hr />
                <div className='addfamily_modal_buttons'>  
                    <div><span id='verification_msg' style={errorNotify === '✔️ No errors found' ? {backgroundColor: 'rgb(88, 255, 88)'} : null}>{errorNotify ? errorNotify : null}</span></div>

                    <div>
                        <button className='addfamily_person_btn_goBack' onClick={() => {nextStep(true); resetFields()}}>Go back</button>
                        <button className='addfamily_person_btn' onClick={addPerson}>Add person</button>
                    </div>
                </div>
            </div>
    
        }
    </div>
  )
}

export default AddFamilyModal